import React from 'react';
import styled from 'styled-components/macro';
import { Tooltip } from '@mui/material';
import { getAPI } from '@components/submissions/utils';
import IconDownload from '@components/icons/IconDownload';
import MenuButton from '@components/controls/MenuButton/MenuButton';
import IconScore from '@components/icons/IconScore';
import StatusIndicator from '@components/submissions/components/StatusIndicator';
import DetailsIcon from '@components/icons/details.icon';

export const tableFields = [
  { value: 'status', label: 'Status', width: 60 },
  { value: 'download', label: '', width: 40 },
  { value: 'details', label: '', width: 40 },
  { value: 'score', label: 'Score', width: 80 },
  { value: 'name', label: 'Submission Title', width: 250 },
  { value: 'author', label: 'Author', width: 150 },
  { value: 'submissionDate', label: 'Submission Date', width: 200 },
  { value: 'expirationDays', label: 'Expiration (Days)', width: 120 },
];

const truncateString = (str, maxLength) => {
  if (str.length <= maxLength) {
    return str;
  } else {
    return str.slice(0, maxLength) + '...';
  }
};

export const getTableRows = (submissions, handleDetails) => {
  let rows = [];
  if (!submissions || !submissions.length) return rows;
  for (const item of submissions) {
    // console.log(item);
    let row = {};
    for (const field of tableFields) {
      if (['name'].includes(field.value)) {
        row[field.value] = truncateString(item[field.value], 64);
      } else if (['author'].includes(field.value)) {
        row[field.value] = truncateString(item[field.value], 64);
      } else if (field.value === 'download') {
        if (item.status === 'finished' && item.expirationDays > 0) {
          row[field.value] = (
            <Tooltip title={'Download Report'} placement={'bottom-end'} arrow>
              <StyledA
                href={getAPI() + `/api/submission/download/${item.hash}`}
                className='text-deep my-0'
                download
                onClick={(e) => e.stopPropagation()}
              >
                <IconDownload />
              </StyledA>
            </Tooltip>
          );
        }
      } else if (field.value === 'details') {
        row[field.value] = (
          <MenuButton
            icon={<DetailsIcon />}
            onClick={(e) => handleDetails(e, item.hash)}
            spacing={'horizontal'}
            text={'View Submission Details'}
            tooltipPlacement={'bottom-end'}
          />
        );
      } else if (field.value === 'score') {
        if (item.status === 'finished') {
          row[field.value] = <IconScore score={item.score} size={48} />;
        }
      } else if (field.value === 'submissionDate') {
        row[field.value] =
          new Date(item.submissionDate).toLocaleDateString() +
          ' ' +
          new Date(item.submissionDate).toLocaleTimeString();
      } else if (field.value === 'expirationDays') {
        if (item.status === 'finished') {
          row[field.value] =
            item.expirationDays > 0 ? item.expirationDays : 'expired';
        }
      } else if (field.value === 'status') {
        row[field.value] = <StatusIndicator status={item.status} />;
      }
    }
    rows.push(row);
  }
  return rows;
};

const StyledA = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  filter: grayscale(1) brightness(${(p) => p.theme.menu.inActive.brightness})
    contrast(${(p) => p.theme.menu.inActive.contrast});
  :hover {
    filter: grayscale(0) brightness(${(p) => p.theme.menu.active.brightness})
      contrast(${(p) => p.theme.menu.active.contrast});
  }
`;
